define('modules/includes_editor/views/list',['require','exports','module','base/collectionview','./list_item','./list_item_editable'],function(require, exports, module){
  "use strict";
  var CollectionView = require("base/collectionview"),
      IncludeItemView = require("./list_item"),
      IncludeItemViewEditable = require("./list_item_editable");

  module.exports = CollectionView.extend({
    itemView: IncludeItemView,
    attributes: { style: "max-height: 400px; overflow: auto", class: 'fields--wrapper' },
    initialize: function(options){
      this.editorState = options.state;
      if (options.editableItemName) this.itemView = IncludeItemViewEditable;
      //this.listenTo(this.childVent, "item:select", this.onListItemSelected);
    },
    onListItemSelected: function(childView, model){
      this.state.set("selectedItem", model);
    }
  });
});

